@if ((tableVm$ | async)) {
  @if (showTable && tableConfig) {
    <snelstart-ui-table [config]="tableConfig">
      <snelstart-ui-table-col
        [showFilter]="false"
        [showSort]="false"
        columnType="string"
        name="label"
        width="400px"
      >
        <snelstart-ui-table-col-header>
          <div style="font-size: 13px; color: #00200b ">
            @if (!this.hasPartner) {
              {{ (clientEntity$ | async)?.name }}
            } @else {
              {{ (clientEntity$ | async)?.name }} en partner
            }
          </div>
        </snelstart-ui-table-col-header>

        <snelstart-ui-table-expanded-row>
          <ng-template let-entity>
            @for (subOnderdeel of entity?.subonderdelen ?? []; track subOnderdeel.value) {
              @if (subOnderdeel.visible) {
                <div>
                  <snelstart-ui-button
                    (click)="navigateToSubPage(subOnderdeel.pageMapping)"
                    class="ps-5"
                    icon="chevron-right"
                    type="link">
                    <div
                      [ngStyle]="subOnderdeel.pageMapping === activePage ? {'color': '#0073dd', 'font-weight': 'bold'} : {}">
                      {{ subOnderdeel.label }}
                    </div>
                  </snelstart-ui-button>
                </div>
              }
            }
          </ng-template>
        </snelstart-ui-table-expanded-row>
      </snelstart-ui-table-col>

      <snelstart-ui-table-col [decimals]="2"
                              [showFilter]="false"
                              [showSort]="false"
                              columnType="currency"
                              i18n-displayName
                              name="onderdelenAanvullendeTekst"
                              width="250px">
        <snelstart-ui-table-col-header></snelstart-ui-table-col-header>

        <snelstart-ui-table-col-data>
          <ng-template let-record="record">
            @if (record.value === 0) {
              <a>Bedrag zorgtoeslag:</a>
            }
            @if (record.value === 1) {
              <a>Bedrag kindgebonden budget:</a>
            }
            @if (record.value === 2) {
              <a>Bedrag kinderopvangtoeslag:</a>
            }
            @if (record.value === 3) {
              <a>Bedrag huurtoeslag:</a>
            }
            @if (record.value === 4) {
              @if (this.sumSaldo >= 0) {
                <a>Nog te betalen:</a>
              } @else {
                <a>Nog te ontvangen:</a>
              }
            }
          </ng-template>
        </snelstart-ui-table-col-data>
      </snelstart-ui-table-col>

      <snelstart-ui-table-col [decimals]="2"
                              [showFilter]="false"
                              [showSort]="false"
                              columnType="currency"
                              i18n-displayName
                              name="berekening"
                              width="250px"
      >
        <snelstart-ui-table-col-header>
          <div style="font-size: 13px; color: #00200b ">
            <!--          {{ this.allowanceEntity.year }}-->
          </div>
        </snelstart-ui-table-col-header>

        <snelstart-ui-table-col-data>
          <ng-template let-record="record">
            @if (record.value === 0) {
              <a>{{ (this.rechtOpZorg || 0).toLocaleString() }}</a>
            }
            @if (record.value === 1) {
              <a>{{ (this.rechtOpKgb || 0).toLocaleString() }}</a>
            }
            @if (record.value === 2) {
              <a>{{ (this.rechtOpKot || 0).toLocaleString() }}</a>
            }
            @if (record.value === 3) {
              <a>{{ (this.rechtOpHuur || 0).toLocaleString() }}</a>
            }
            @if (record.value === 4) {
              <a>{{ (this.sumSaldo).toLocaleString() }}</a>
            }
          </ng-template>
        </snelstart-ui-table-col-data>
      </snelstart-ui-table-col>
    </snelstart-ui-table>
  }

<snelstart-venture-fiscaal-domain-logic-service
  [(dialogVisible)]="this.dialogVisible"
  (created)="onAllowanceCreated()"
  [title]="'Nieuwe toeslagen aan'"
>
</snelstart-venture-fiscaal-domain-logic-service>
}
